import React, { useState } from 'react'
import { Input, Button } from 'components/UIElements'
import STRINGS from 'utils/strings'
import { isValidVersion } from '../utils/studyUtils'

const EditStudyVersionPopup = ({
  closeModal,
  editStudyVersionNumber,
  fetchStudyVersionList,
  studyId,
  studyVersionID,
  currentStudyVersion,
}) => {
  const [value, setValue] = useState('')
  const [error, setError] = useState('')

  return (
    <div className='edit-study-version-popup'>
      <h6 className='label-large light-grey edit-study-version-title'>{STRINGS.editStudyVersion}</h6>
      <div className='edit-study-version-subtitle top'>{STRINGS.enterNewStudyVersion}</div>
      <div className='edit-study-version-input-box'>
        <Input
          className='name'
          hasError={!!error}
          errorText={error}
          label={STRINGS.studyVersionNumber}
          disabled={false}
          value={value}
          onChange={newValue => {
            setValue(newValue)

            if (error) setError('')
          }}
          id='study-version-number'
          placeholder={'1.0'}
          wrapError
        />
      </div>
      <div className='edit-study-version-buttons'>
        <Button
          grey
          id='modal-cancel'
          content={STRINGS.cancel}
          onClick={() => {
            closeModal()
            setError('')
            setValue('')
          }}
        />
        <Button
          id='modal-confirm'
          disabled={!value}
          className='confirm'
          content={STRINGS.confirm}
          onClick={async () => {
            const digitFormat = /^\d{1,2}\.\d{1,2}$/

            if (!digitFormat.test(value) || !isValidVersion(value, currentStudyVersion?.version_display_number)) {
              setError(STRINGS.invalidVersionNumber)
            } else {
              try {
                await editStudyVersionNumber(studyId, studyVersionID, value)
                await fetchStudyVersionList(studyId)
                setError('')
                closeModal()
              } catch (err) {
                console.log(err)
              }
            }
          }}
        />
      </div>
    </div>
  )
}

export default EditStudyVersionPopup
